import { SUCCESS_PLAN_LEVELLED, ERROR_PLAN_LEVELLED } from '../../actionType';
import giftCodeApi from '../api/giftCode';

export const successGetLevelled = payload => ({
	type: SUCCESS_PLAN_LEVELLED,
	payload
});
export const errorGetLevelled = payload => ({
	type: ERROR_PLAN_LEVELLED,
	payload
});

export const verifyCodeLevelled = (code, store) => async dispatch => {
	/*const response = {
		status: 'success',
		message: 'Code available to be redeemed',
		giftCode: { code: 'egn1wqvqv81k', id: '401', status: 'ACTIVATED' },
		plan: {
			id: '114',
			signatureType: 'familia',
			value: '179.70',
			name: 'YALO Telemedicina Trimestral'
		},
		number_of_dependents: '0'
		active_dependents: '1',
		name_site: 'Yalo'
	};
	let hasError = '';
	dispatch(successGetLevelled(response));
	return (hasError = false); //mock
*/

	try {
		const levelledResponse = await giftCodeApi.sendingCode(code, store);
		let hasError = '';
		if (levelledResponse === undefined) {
			hasError = true;
		} else if (levelledResponse.data.status === 'success') {
			dispatch(successGetLevelled(levelledResponse.data));
			hasError = false;
		} else {
			hasError = 'true1';
		}
		return hasError;
	} catch (err) {}
	//
};
